var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "page-honor" }, [
      _c("div", { staticClass: "content-wrap" }, [
        _c("h1", { staticClass: "h1 color-black" }, [
          _vm._v("荣誉学生评选标准")
        ]),
        _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [
          _vm._v("参与对象")
        ]),
        _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
          _vm._v(
            " 所有参加本届峰会的学⽣都将⾃动被纳⼊荣誉毕业⽣考察范围，⽆需额外申请。荣誉学生和最高荣誉学生的设置，是为了表彰和鼓励在峰会学术体系获得优异成绩，并能遵守峰会规范准则的学生。荣誉和最高荣誉学生的结果将会与峰会成绩⼀起在9⽉中公布，请留意届时的邮件通知。 "
          )
        ]),
        _c("h2", { staticClass: "h2 color-gray-1 mt-30" }, [
          _vm._v("评选标准")
        ]),
        _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
          _vm._v(
            " 峰会里的荣誉评定，主要由你的 GPA 相对排名决定，在完成毕业基本学术要求以外，必须达到荣誉学生学术要求，并主动遵守行为准则，积极参与峰会中的各项活动。荣誉（Honor）的比例为本场次所有学生排名的前8%，最高荣誉（High Honor）的比例前3%，同时还会兼顾考量你在峰会和House活动里的参与情况和行为表现。你需要⽐别⼈完成得更加出⾊，才有可能成为峰会的“荣誉毕业⽣”。 "
          )
        ]),
        _c("div", { staticClass: "points-wrap mt-30" }, [
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title-wrap h3 color-gray-1" }, [
              _c("div", { staticClass: "title-content" }, [_vm._v("评选要求")])
            ]),
            _c("div", { staticClass: "item-content" }, [
              _c("ul", { staticClass: "ul color-gray-2 text1" }, [
                _c("li", [_vm._v("平均GPA不低于3.8（满分4.0）")]),
                _c("li", [_vm._v("Honor：总排名位列于所有2022届学生的前8%；")]),
                _c("li", [
                  _vm._v(
                    "High Honor：总排名位列于所有2022届学生的前1-3%且所有打分制课程（Seminar & Capstone）取得A或A+等级；"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    " 峰会三个场次期间（7月19日-8月22日）共参加3次Cornerstone Workshop大学能力强化课 "
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title-wrap h3 color-gray-1" }, [
              _c("div", { staticClass: "title-content" }, [_vm._v("行为准则")])
            ]),
            _c("div", { staticClass: "item-content" }, [
              _c("ul", { staticClass: "ul color-gray-2 text1" }, [
                _c("li", [
                  _vm._v(
                    "不违反任何峰会纪律规定，主动遵守行为准则，给同学和⽼师留下良好的印象。"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "积极参与House团队建设和活动比拼，为House荣誉作出自己的贡献。"
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", { staticClass: "title-wrap h3 color-gray-1" }, [
              _c("div", { staticClass: "title-content" }, [_vm._v("加分项")])
            ]),
            _c("div", { staticClass: "item-content" }, [
              _c("ul", { staticClass: "ul color-gray-2 text1" }, [
                _c("li", [
                  _vm._v(
                    "主动申请 HSYLC÷ 中的更多挑战，比如成为SSI、入选HAA校园大使、申请并入选SBP等；"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "积极参加峰会期间的各项活动，例如师生对话时间 Office Hour、兴趣社团HSYLC Interest Hub、学院杯 House Cup、House Game等；"
                  )
                ]),
                _c("li", [
                  _vm._v(
                    "如果出现多个成绩相同的学生而荣誉比例有限，则荣誉学生和最高荣誉学生将优先给予在加分项中更积极参与的学生。"
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }